import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { canActivateAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { ConferenceListComponent } from './conference-list/conference-list.component';


const routes: Routes = [
  {
    path:'',
    component: ConferenceListComponent,
    canActivate: [ canActivateAuthGuard ]
  },
  {
    path: 'signin-oidc',
    component: OktaCallbackComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})], 
  exports: [RouterModule]
})
export class AppRoutingModule { }
